import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search.svg",
  "use": "search.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"search.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.71 9.482a6.773 6.773 0 1113.546 0 6.773 6.773 0 01-13.547 0zM9.481 0a9.483 9.483 0 105.679 17.076l6.527 6.527a1.355 1.355 0 001.915-1.915l-6.527-6.527A9.483 9.483 0 009.482 0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol